<template>
  <div>
    <div id="box" class="gradient-border">
      <p class="mb-0">
        {{ text }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: String,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
#box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8rem;
  height: 2rem;
  color: white;
  font-size: 1rem;
  padding: var(--borderWidth);
  position: relative;
  z-index: 1;
  border-radius: var(--borderWidth);
}

.gradient-border {
  --borderWidth: 3px;
}

.gradient-border:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  margin: -var(--borderWidth);
  background: linear-gradient(30deg, #eaaa00, #dc582a);
  border-radius: calc(4 * var(--borderWidth));
  animation: animatedgradient 5s ease-in-out alternate infinite;
  background-size: 600% 600%;
}

@keyframes animatedgradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
